import store from "./store/index";

export const fireNotification = (data) => {
  if (!data.hasOwnProperty("response")) return;
  let baseURL = data.response.config.baseURL;
  if (data.response.status == 404 || data.response.status == "404") {
    if (baseURL != "https://api.gozwing.com") {
      return;
    }
  }
  if (data.response != undefined) {
    let udid = get_UDID();
    let url =
      "https://hooks.slack.com/services/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";
    let config = JSON.parse(data.response.config.data);
    let payload = {
      text:
        baseURL == "https://api.gozwing.com"
          ? "*Server Error!(Production Server) " +
            "Error Code: " +
            data.response.status +
            "* :male-mechanic: :webpos:"
          : "Server Error! " +
            "Status Code: *" +
            data.response.status +
            "* :sob: :webpos:",
      attachments: [
        {
          color:
            baseURL == "https://api.gozwing.com"
              ? "#FF0000"
              : baseURL == "https://staging.api.gozwing.com"
              ? "#3CBA54"
              : baseURL == "https://demo.api.gozwing.com/"
              ? "#3F51B5"
              : baseURL == "https://test.api.gozwing.com/"
              ? "#10B4EA"
              : baseURL == "https://dev.api.gozwing.com/"
              ? "#9C27B0"
              : "#ec8f90",
          fields: [
            {
              title: "Vendor_ID | Store_ID | Vu_ID",
              value: config.hasOwnProperty("v_id")
                ? config.v_id + " | " + config.store_id + " | " + config.vu_id
                : "- | - | -",
              short: true,
            },
            {
              title: "Store Name",
              value:
                store.state.system.settings != "" &&
                store.state.system.settings.hasOwnProperty("store") &&
                store.state.system.settings.store.hasOwnProperty("name")
                  ? store.state.system.settings.store.name
                  : "-",
              short: true,
            },
            {
              title: "User Mobile",
              value:
                (store.state.sessions.user.hasOwnProperty("mobile") &&
                  store.state.sessions.user.mobile != "") ||
                store.state.sessions.user.mobile != undefined
                  ? store.state.sessions.user.mobile
                  : "-",
              short: true,
            },
            {
              title: "Terminal ID | UDID",
              value:
                store.state.system.settings != "" &&
                store.state.system.settings.hasOwnProperty("terminal_id")
                  ? store.state.system.settings.terminal_id + " | " + udid
                  : "-" + " | " + udid,
              short: true,
            },
            {
              title: "Error URL",
              value: data.response.config.url,
              short: false,
            },
          ],
        },
      ],
    };
    // console.log(payload);
    fetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
};

export const get_UDID = () => {
  // let client = new ClientJS();
  // let ua = client.getBrowserData().ua;
  // let canvasPrint = client.getCanvasPrint();

  // var getUDID =
  //   client.getFingerprint() +
  //   client.getCustomFingerprint(ua, canvasPrint).toString();

  // let biri = require("biri");
  // const uniqueId = await biri();

  return store.state.system.device_info;
};
